export default __webpack_public_path__ + "static/media/goopter-ecommerce-ordering-highlights.ca01e112.jpg";